// Tiles
import { PATIENT_TYPE_KIDS } from '../../../constants';
import {
  ALLERGIST_VALUE,
  CHIROPRACTOR_VALUE,
  DENTIST_VALUE,
  DERMATOLOGIST_VALUE,
  IMAGING_VALUE,
  OB_GYN_VALUE,
  OPTOMETRIST_VALUE,
  URGENT_CARE_VALUE,
} from './ProviderTypes';

export const COLD_AND_COUGH = 'Flu, cold, or cough';
export const CONGESTION_OR_SINUS_PAIN = 'Sinus infection';
export const EAR_PAIN_OR_INFECTION = 'Ear ache';
export const FEVER = 'Fever';
export const RASH = 'Rash';
export const SCHOOL_PHYSICAL = 'School physical';
export const SORE_THROAT = 'Sore throat';
export const URINARY_TRACT_INFECTION = 'Urinary tract infection (UTI)';
export const WOUNDS_OR_STITCHES = 'Wounds or stitches';
export const INSECT_BITE = 'Insect bite';
export const ALLERGIES = 'Allergies';
export const ACNE = 'Acne';
export const STD_TEST = 'STD Test';
export const SPRAIN = 'Sprain or broken bone';
export const SKIN_ALLERGY = 'Skin allergy';
export const BACK_PAIN = 'Back pain';
export const TOOTH_PAIN = 'Tooth pain';
export const PREGNANCY = 'Pregnancy';
export const RED_EYES = 'Red eyes';
export const BROKEN_BONE = 'Broken bone';

export const PEDIATRIC_CARE = 'Pediatric urgent care';

// Traditional Conditions
export const BACK_ADJUSTMENT = 'Back adjustment';
export const EYE_EXAM = 'Eye exam';
export const FLU_SHOT = 'Flu shot';
export const SKIN_SCREENING = 'Skin screening';
export const TEETH_CLEANING = 'Teeth cleaning';

export const ANOTHER_SERVICE = 'Another service';
export const NEED_HELP = 'Need help';

export const symptomTiles = inMarket => {
  const symptoms = {
    outOfMarket: [
      {
        symptom: COLD_AND_COUGH,
        icon: '/images/icons/symptoms/uc_flu.svg',
      },
      {
        symptom: EAR_PAIN_OR_INFECTION,
        icon: '/images/icons/symptoms/uc_earache.svg',
      },
      {
        symptom: SORE_THROAT,
        icon: '/images/icons/symptoms/uc_sorethroat.svg',
      },
      {
        symptom: WOUNDS_OR_STITCHES,
        icon: '/images/icons/symptoms/uc_stitches.svg',
      },
      {
        symptom: INSECT_BITE,
        icon: '/images/icons/symptoms/uc_insectbite.svg',
      },
      { symptom: SPRAIN, icon: '/images/icons/symptoms/uc_sprain.svg' },
      {
        symptom: CONGESTION_OR_SINUS_PAIN,
        icon: '/images/icons/symptoms/uc_sinus.svg',
      },
      { symptom: ALLERGIES, icon: '/images/icons/symptoms/uc_allergy.svg' },
      { symptom: RASH, icon: '/images/icons/symptoms/uc_rash.svg' },
      { symptom: ACNE, icon: '/images/icons/symptoms/uc_acne.svg' },
      {
        symptom: URINARY_TRACT_INFECTION,
        icon: '/images/icons/symptoms/uc_uti.svg',
      },
      { symptom: FEVER, icon: '/images/icons/symptoms/uc_fever.svg' },
    ],
    inMarket: [
      {
        symptom: SKIN_ALLERGY,
        icon: '/images/icons/symptoms/allergist_skinallergy.svg',
        providerType: ALLERGIST_VALUE,
      },
      {
        symptom: BACK_PAIN,
        icon: '/images/icons/symptoms/chiropractor_backpain.svg',
        providerType: CHIROPRACTOR_VALUE,
      },
      {
        symptom: TOOTH_PAIN,
        icon: '/images/icons/symptoms/dentist_toothpain.svg',
        providerType: DENTIST_VALUE,
      },
      {
        symptom: ACNE,
        icon: '/images/icons/symptoms/dermatologist_acne.svg',
        providerType: DERMATOLOGIST_VALUE,
      },
      {
        symptom: PREGNANCY,
        icon: '/images/icons/symptoms/ob_pregnancy.svg',
        providerType: OB_GYN_VALUE,
      },
      {
        symptom: RED_EYES,
        icon: '/images/icons/symptoms/optometrist_redeyes.svg',
        providerType: OPTOMETRIST_VALUE,
      },
      {
        symptom: BROKEN_BONE,
        icon: '/images/icons/symptoms/imaging_brokenbone.svg',
        providerType: IMAGING_VALUE,
      },
      {
        symptom: COLD_AND_COUGH,
        icon: '/images/icons/symptoms/uc_flu.svg',
        providerType: URGENT_CARE_VALUE,
      },
      {
        symptom: WOUNDS_OR_STITCHES,
        icon: '/images/icons/symptoms/uc_stitches.svg',
        providerType: URGENT_CARE_VALUE,
      },
      {
        symptom: FEVER,
        icon: '/images/icons/symptoms/uc_fever.svg',
        providerType: URGENT_CARE_VALUE,
      },
      {
        symptom: INSECT_BITE,
        icon: '/images/icons/symptoms/uc_insectbite.svg',
        providerType: URGENT_CARE_VALUE,
      },
      {
        symptom: SORE_THROAT,
        icon: '/images/icons/symptoms/uc_sorethroat.svg',
        providerType: URGENT_CARE_VALUE,
      },
    ],
  };
  return symptoms[`${inMarket ? 'inMarket' : 'outOfMarket'}`];
};
